import { StatusActiveIcon } from '@tableau/icons/StatusActiveIcon';
import { StatusDownIcon } from '@tableau/icons/StatusDownIcon';
import { StatusErrorIcon } from '@tableau/icons/StatusErrorIcon';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { statusIconClass } from '~src/settings/bridge-settings/sections/bridgeRemoteAgents/RemoteAgentPresenceIcon';
import { IRemoteAgentConnectionStatus } from '~src/settings/bridge-settings/serverApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import { IRemoteQueryAgent, RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';

import { getAgentStatus } from '../bridgeRemoteAgents/BridgeRemoteAgentsPresenceIcon';
import { UserDefinedPoolModel } from '../types/PoolModel';

export type PoolStatusIconProps = Readonly<{
  pool: UserDefinedPoolModel;
  connectionStatuses: IRemoteAgentConnectionStatus[];
}>;

export function PoolStatusIcon(props: PoolStatusIconProps) {
  const {pool, connectionStatuses} = props;
  let statusIcon: React.ReactNode;
  let statusMessage: string;
  const agents: IRemoteQueryAgent[] = Object.values(pool.agents);

  if (agents.length === 0) {
    statusIcon = <StatusErrorIcon size={18} alt='' className={statusIconClass} />;
    statusMessage = Messages.bridgeSiteSettingsPoolStatusError();
  } else if (hasActiveAgents(agents, connectionStatuses)) {
    statusIcon = <StatusActiveIcon size={18} alt='' className={statusIconClass} />;
    statusMessage = Messages.bridgeSiteSettingsPoolStatusReady();
  } else {
    statusIcon = <StatusDownIcon size={18} alt='' className={statusIconClass} />;
    statusMessage = Messages.bridgeSiteSettingsPoolStatusDown();
  }

  return renderStatusIcon(statusIcon, statusMessage);
}

function renderStatusIcon(statusIcon: React.ReactNode, statusMessage: string) {
  return <>
    {statusIcon}
    <span>{statusMessage}</span>
  </>;
}

function hasActiveAgents(agents: IRemoteQueryAgent[], connectionStatuses: IRemoteAgentConnectionStatus[]) {
  if (agents.some(agent =>
    getAgentStatus(agent, connectionStatuses)?.connectionStatus === RemoteAgentConnectionStatus.CONNECTED)) {
    return true;
  }
  return false;
}
